import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-delete-users-dialog',
  templateUrl: './delete-users-dialog.component.html',
  styleUrls: ['./delete-users-dialog.component.scss']
})
export class DeleteUsersDialogComponent {

  @Input() selectedUser: number[] = []
  @Input() userName: string | undefined
  @Input() userId: number | undefined

  @Output() deleteUserEvent: EventEmitter<string> = new EventEmitter<string>()

  constructor(
    private modalService: ModalService
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  deleteUsers() {
    if (this.selectedUser.length === 0 && this.userId) {
      this.deleteUserEvent.emit(this.userId.toString())
    } else {
      this.deleteUserEvent.emit(this.selectedUser.join(','))
    }
  }
}
